module.exports = __webpack_public_path__ + "img/2.f41f6a16.png";